module.exports = __webpack_public_path__ + "static/logo_elecboy-3ebfdbfeecd16858ac77a402d5286051.svg";